<template>
    <div class="rooms">
        <div class="page-header">
            <h1>
                Settings
            </h1>
        </div>

        <div class="row">
            <loader v-if="!hasLoaded"></loader>

            <div class="col-lg-6 col-lg-offset-2 col-md-8 col-md-offset-1 col-sm-12" v-else>
                <form class="form-horizontal">
                    <div class="form-group" v-for="property in sortedMeta">
                        <label class="col-sm-4 control-label">{{property.label}}</label>
                        <div class="col-sm-8">
                            <input @keyup="addUpdate" :data-field="property.field" type="text" class="form-control" :value="property.value" v-if="property.type === null || property.type === 'text'">
                            <textarea @keyup="addUpdate" :data-field="property.field" class="form-control" :value="property.value" v-else-if="property.type === 'textarea'"></textarea>
                        </div>
                    </div>

                    <br />

                    <div class="form-group">
                        <div class="col-sm-offset-4 col-sm-8">
                            <button type="button" class="btn btn-primary" @click="update">Update information</button>
                        </div>
                    </div>

                    <br />

                    <hr />

                    <div class="text-center">
                        <button class="btn btn-primary" @click="signOut">Click here to sign out</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .rooms {
        .list-group {
            .list-group-item {
                padding: 25px;

                .action {
                    color: #828282;
                    font-size: 25px;
                }

                &:hover,
                &.navigation-selected-active {
                    color: #555;
                    text-decoration: none;
                    background-color: #f5f5f5;

                    .action {
                        color: #ff3d70;
                    }
                }
            }
        }
    }
</style>

<script>
    import Loader from '@/components/layout/Loader'
    import {mapActions} from 'vuex'

    const MetaService = require('@/services/hotel/MetaService')

    export default {
        data() {
            return {
                hasLoaded: false,
                meta: [],
                updates: {}
            }
        },

        computed: {
            sortedMeta() {
                return this.meta.sort((a, b) => {
                    return a.order - b.order
                })
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            ...mapActions({
                signOut: 'authSignOut'
            }),

            load() {
                this.hasLoaded = false
                this.updates = {}

                MetaService.findAll({}, (response) => {
                    const data = response.data

                    this.meta = data.rows

                    this.meta.forEach((property) => {
                        this.updates[property.field] = property.value
                    })

                    this.hasLoaded = true
                })
            },

            addUpdate(event) {
                if (!this.hasLoaded) {
                    return
                }

                const element = event.srcElement
                const field = element.getAttribute('data-field')
                const value = element.value

                this.$set(this.updates, field, value)
            },

            update() {
                this.hasLoaded = false

                const keys = Object.keys(this.updates)

                keys.forEach((key) => {
                    MetaService.update(key, {value: this.updates[key]})
                })

                setTimeout(() => {
                    this.load()
                }, 400)
            }
        },

        components: {
            Loader
        }
    }
</script>


// WEBPACK FOOTER //
// Settings.vue?8e786dda